import onInitialTableLoadComplete from 'owa-mail-table-loading-actions/lib/actions/onInitialTableLoadComplete';
import loadInitialRowsFromServer from 'owa-mail-list-actions/lib/actions/table/loadInitialRowsFromServer';
import { INITIAL_LOAD_ROW_COUNT } from 'owa-mail-triage-common';
import {
    getGQLPagingInfoForQueryRowsForJumpTo,
    resetTableViewPropertiesMutator,
    isMailListConversationView,
} from 'owa-mail-list-store';
import type { MailFolderTableQuery, TableView } from 'owa-mail-list-store';
import { logUsage } from 'owa-analytics';
import { getAggregationBucket } from 'owa-analytics-actions';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';

export default function executeJumpTo(tableView: TableView, matchingString: string): void {
    // We don't want to jump in the list while the tableView is loading because that can cause unexpected behavior of rows
    // being fetched from the previous table getting appended to the jump to results.
    if (tableView.isLoading) {
        return;
    }

    const tableQuery = tableView.tableQuery as MailFolderTableQuery;

    const isConversationView = isMailListConversationView(tableView);

    const customPagingInfo = getGQLPagingInfoForQueryRowsForJumpTo(
        INITIAL_LOAD_ROW_COUNT,
        isConversationView,
        matchingString,
        tableQuery.sortBy
    );

    logUsage('JumpTo_Triggered', getMailboxInfo(tableView), {
        sortColumn: tableQuery.sortBy.sortColumn,
        sortOrder: tableQuery.sortBy.sortDirection,
        isConversationView,
        numRowKeysInTable: getAggregationBucket({
            value: tableView.rowKeys.length,
            buckets: [10, 25, 50, 100, 250, 500],
        }),
    });

    resetTableViewPropertiesMutator(tableView);

    loadInitialRowsFromServer(
        tableView,
        false /*isTablePrefetched*/,
        onInitialTableLoadComplete,
        undefined /*initialSessionData*/,
        false /*skipGqlTimings*/,
        customPagingInfo
    );
}
